module.exports = "<spinner promise=\"reportPromise\" size=\"3\" message=\"'Loading report...'\"></spinner>\n";